import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ.js";
import {useNavigate} from "react-router-dom";
import "./IoTStyles.css";
function IoTDevices() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    // ============================================================
    // FETCH DEVICES
    // ============================================================
    const fetchDevices = async () => {
        try {
            setIsLoading(true);
            let url = baseUrl + "iot-devices/";
            if (search.trim() !== "") {
                url += "?search=" + encodeURIComponent(search);
            }
            const response = await axios.get(url);
            setRows(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.log("IoT Device Error:", error);
            Swal.fire("Error", "Unable to load IoT devices.", "error");
        } finally {
            setIsLoading(false);
        }
    };
    // ============================================================
    // INITIAL LOAD
    // ============================================================
    useEffect(() => {
        fetchDevices();
    }, []);
    // ============================================================
    // DELETE DEVICE
    // ============================================================
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Device?",
            text: "This agricultural IoT device will be removed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            await axios.delete(baseUrl + "iot-devices/" + id + "/");
            Swal.fire("Deleted", "IoT device has been deleted.", "success");
            fetchDevices();
        } catch (error) {
            console.log("Delete IoT Device Error:", error);
            Swal.fire("Error", "Unable to delete IoT device.", "error");
        }
    };
    // ============================================================
    // DATA GRID COLUMNS
    // ============================================================
    const columns = [{
        field: "id", headerName: "ID", width: 70
    }, {
        field: "device_id", headerName: "Device ID", width: 170
    }, {
        field: "device_name", headerName: "Device", width: 200
    }, {
        field: "device_type", headerName: "Device Type", width: 180
    }, {
        field: "manufacturer", headerName: "Manufacturer", width: 160
    }, {
        field: "model_number", headerName: "Model", width: 140
    }, {
        field: "serial_number", headerName: "Serial Number", width: 170
    }, {
        field: "protocol", headerName: "Protocol", width: 130
    }, {
        field: "ip_address", headerName: "IP Address", width: 150
    }, {
        field: "is_online",
        headerName: "Status",
        width: 120,
        renderCell: (params) => (params.value ? <span className="iot-status online">
                        ONLINE
                    </span> : <span className="iot-status offline">
                        OFFLINE
                    </span>)
    }, {
        field: "last_seen", headerName: "Last Seen", width: 190
    }, {
        field: "actions",
        headerName: "Action",
        width: 270,
        sortable: false,
        filterable: false,
        renderCell: (params) => (<div className="iot-action-buttons">

                {/* EDIT */}

                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate("/iot-device-form/" + params.row.id)}
                >
                    Edit
                </button>


                {/* MAP */}

                <button
                    className="btn btn-info btn-sm"
                    onClick={() => navigate("/iot-device-mapping/" + params.row.id)}
                >
                    Map
                </button>


                {/* DELETE */}

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(params.row.id)}
                >
                    Delete
                </button>

            </div>)
    }];
    // ============================================================
    // PAGE
    // ============================================================
    return (<section className="container-fluid mt-4">

            {/* ==================================================
                HEADER
            ================================================== */}

            <div className="iot-page-header">

                <div>

                    <h3>
                        Agricultural IoT Devices
                    </h3>

                    <p>
                        Manage sensors, controllers and
                        agricultural IoT devices
                    </p>

                </div>


                <button
                    className="btn btn-success"
                    onClick={() => navigate("/iot-device-form/")}
                >
                    + Add Device
                </button>

            </div>


            {/* ==================================================
                SEARCH
            ================================================== */}

            <div className="card shadow-sm mb-3">

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-8">

                            <input
                                type="text"

                                className="form-control"

                                placeholder={"Search Device ID, Device, " + "Manufacturer, Model, " + "Serial Number..."}

                                value={search}

                                onChange={(e) => setSearch(e.target.value)}

                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        fetchDevices();
                                    }
                                }}

                            />

                        </div>


                        <div className="col-md-2">

                            <button
                                className="btn btn-primary w-100"
                                onClick={fetchDevices}
                            >
                                Search
                            </button>

                        </div>


                        <div className="col-md-2">

                            <button
                                className="btn btn-secondary w-100"
                                onClick={() => {
                                    setSearch("");
                                    setTimeout(fetchDevices, 100);
                                }}
                            >
                                Reset
                            </button>

                        </div>

                    </div>

                </div>

            </div>


            {/* ==================================================
                DEVICE GRID
            ================================================== */}

            <div
                style={{
                    width: "100%"
                }}
            >

                <DataGrid

                    className="mt-3"

                    rows={rows}

                    columns={columns}

                    loading={isLoading}

                    autoHeight

                    disableRowSelectionOnClick

                    pageSizeOptions={[10, 25, 50, 100]}

                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 25, page: 0
                            }
                        }
                    }}

                    slots={{
                        toolbar: GridToolbar
                    }}

                    sx={{
                        boxShadow: 3, "& .MuiDataGrid-cell:hover": {
                            color: "primary.main"
                        }
                    }}

                />

            </div>

        </section>);
}
export default IoTDevices;
